export default "__VITE_ASSET__BDXfHFV4__"